import { render } from "./RegistrationReasonsEditing.vue?vue&type=template&id=6d0d6a3e&ts=true"
import script from "./RegistrationReasonsEditing.vue?vue&type=script&lang=ts"
export * from "./RegistrationReasonsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__